export default __webpack_public_path__ + "static/media/Fail.7854128a.svg";